import { TeamRole } from 'containers/app/app.model';
import { TeamMemberRoleItems } from './types';

export const teamMemberRoles: TeamMemberRoleItems[] = [
  { name: 'Admin', role: TeamRole.ADMIN, id: TeamRole.ADMIN },
  { name: 'Owner', role: TeamRole.OWNER, id: TeamRole.OWNER },
  { name: 'Member', role: TeamRole.MEMBER, id: TeamRole.MEMBER },
  { name: 'Custom', role: TeamRole.CUSTOM, id: TeamRole.CUSTOM },
  { name: 'Super admin', role: TeamRole.SUPER_ADMIN, id: TeamRole.SUPER_ADMIN },
  { name: 'Dispatch admin', role: TeamRole.DISPATCH_ADMIN, id: TeamRole.DISPATCH_ADMIN }
];

export const dropDownGenericRoles: TeamMemberRoleItems[] = [
  { name: 'Admin', role: TeamRole.ADMIN, id: TeamRole.ADMIN },
  { name: 'Member', role: TeamRole.MEMBER, id: TeamRole.MEMBER },
  { name: 'Dispatch admin', role: TeamRole.DISPATCH_ADMIN, id: TeamRole.DISPATCH_ADMIN }
];

export enum PermissionSettingType {
  TEAM_SETTINGS = 'Team settings',
  INVOICES_AND_RECEIPTS = 'Invoices and Receipts',
  TIPS_AND_FEES = 'Catalog, Payments and Fees',
  REFUNDS = 'Refunds and Disputes',
  CUSTOMERS = 'Customers',
  JOB = 'Jobs',
  ACCOUNTING = 'Accounting',
  REPORTS = 'Reports',
  BANKING = 'Banking (Team)'
}

export enum PermissionSettingKeys {
  TEAM_SETTINGS = 'teamSettings',
  INVOICES_AND_RECEIPTS = 'invoice',
  TIPS_AND_FEES = 'fees',
  REFUNDS = 'refund',
  CUSTOMERS = 'customers',
  BANKING = 'banking',
  JOB = 'job',
  ACCOUNTING = 'accounting',
  REPORTS = 'reports'
}
